import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaLinkedin, FaGithub } from "react-icons/fa";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`header${scrolled ? " scrolled" : ""}`}>
      <div className="nav-inner">
        <div className="header__logo">
          <span>./</span>birla
        </div>
        <ul className="header__nav-item">
          <li className="header__nav-link"><Link to="/">Home</Link></li>
          <li className="header__nav-link"><Link to="/about">About</Link></li>
          <li className="header__nav-link"><Link to="/projects">Projects</Link></li>
          <li className="header__nav-link"><Link to="/skills">Skills</Link></li>
          <li className="header__nav-link"><Link to="/contact">Contact</Link></li>
        </ul>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <ul className="header__nav-item" style={{ margin: 0 }}>
            <li className="header__nav-link">
              <a href="https://www.linkedin.com/in/ravindra-birla-5a6a281b4" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
            </li>
            <li className="header__nav-link">
              <a href="https://github.com/Birlaravi/" target="_blank" rel="noopener noreferrer">
                <FaGithub />
              </a>
            </li>
          </ul>
          <a href="mailto:ravindrabirla20@gmail.com" className="nav-cta">Hire me</a>
        </div>
      </div>
    </nav>
  );
};

export default Header;
